import styled from 'styled-components';

export const Container = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  padding: 0px 20px 0 0;
  width: 100%;
`;

export const PortalContent = styled.div`
  position: absolute;
  padding: 10px;
  background: #ffffff;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  min-width: 240px;
  z-index: 1060;
`;

export const Item = styled.div`
  display: flex;
  padding: 10px;
`;

export const Title = styled.div`
  padding: 10px;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
`;
